module.exports = __webpack_public_path__ + "img/community-avatar.05986343.jpeg";